"use client";

import React, { ReactNode } from "react";
import { cn } from "utils/utils";

export interface MobileFilterBarAction {
  icon: ReactNode;
  label: string;
  onClick: () => void;
  /** Show a badge (e.g., active filter count) */
  badge?: number | string;
  /** Highlight the action as active */
  active?: boolean;
}

interface MobileFilterBarProps {
  actions: MobileFilterBarAction[];
  className?: string;
}

/**
 * A horizontal scrollable chip/filter bar for mobile.
 * Designed to sit below page titles, providing quick access to
 * search, filters, sort, and view options.
 * Only visible on mobile (md:hidden).
 */
export function MobileFilterBar({ actions, className }: MobileFilterBarProps) {
  if (actions.length === 0) return null;

  return (
    <div
      className={cn(
        // px-1 matches the standard grid inset (ResponsiveCardDisplayGrid rows)
        // so pill rows align with card edges on every browsing page
        "no-scrollbar flex min-w-0 gap-2 overflow-x-auto px-1 md:hidden",
        // "no-scrollbar flex gap-2 overflow-x-auto pb-2 md:hidden",
        className
      )}
    >
      {actions.map((action, index) => (
        <button
          key={index}
          type="button"
          onClick={action.onClick}
          className={cn(
            "btn btn-sm btn-soft border-base-300 rounded-full border",
            action.active && "btn-primary"
          )}
        >
          {action.icon}
          {action.label}
          {action.badge !== undefined && (
            <span className="badge badge-sm badge-primary">{action.badge}</span>
          )}
        </button>
      ))}
    </div>
  );
}
